import { Alert, Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { Dialog } from "~/components/dialog";
import { useMultiSelectButton } from "~/hooks/use-multi-select-button";
import { useBulkUpdateFiles } from "~/queries/useBulkUpdateFiles";
import { useGetProcesses } from "~/queries/useGetProcesses";
export const MoveProcessModal = () => {
  const {
    data: processes = []
  } = useGetProcesses();
  const [selProcess, setSelProcess] = useState<string>("");
  const {
    selectedFiles,
    handleMultiSelectButtonClose
  } = useMultiSelectButton();
  const bulkUpdateFiles = useBulkUpdateFiles();
  const handleConfirm = async (processId: string) => {
    if (!selectedFiles || selectedFiles.length < 1) return;
    await toast.promise(
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject) => {
      try {
        const updateInput = selectedFiles.map(f => ({
          id: f,
          input: {
            process: processId
          }
        }));
        await bulkUpdateFiles.mutateAsync({
          inputs: updateInput
        });
        resolve(null);
      } catch (e) {
        reject(e instanceof Error ? e : new Error("Something went wrong"));
      }
    }), {
      loading: "Moving files into process...",
      success: "Files moved successfully",
      error: "Failed to move files"
    });
    handleMultiSelectButtonClose();
  };
  return <Dialog dialogProps={{
    maxWidth: "sm"
  }} title="Move Files Process" content={<>
					<Box sx={{
      display: "flex",
      mb: 2
    }}>
						<Alert severity="info" sx={{
        width: "100%"
      }}>
							You are about to move the selected files into new process.
						</Alert>
					</Box>
					<Box sx={{
      display: "flex",
      mb: 2
    }}>
						<Typography>Select a process</Typography>
					</Box>
					<Box sx={{
      display: "flex",
      alignItems: "center",
      gap: 2
    }}>
						<TextField select label="Process names" sx={{
        width: "100%"
      }} fullWidth value={selProcess} onChange={e => setSelProcess(e.target.value)}>
							{processes.map(process => <MenuItem key={process._id} value={process._id}>
									{process.name}
								</MenuItem>)}
						</TextField>
					</Box>
					<Box sx={{
      display: "flex",
      my: 2
    }}>
						<Button variant="contained" fullWidth onClick={() => {
        if (!selProcess || selProcess === "") return;
        void handleConfirm(selProcess);
      }}>
							Move
						</Button>
					</Box>
					<Box sx={{
      display: "flex",
      mb: 2
    }}>
						<Button variant="outlined" fullWidth onClick={handleMultiSelectButtonClose}>
							Cancel
						</Button>
					</Box>
				</>} data-sentry-element="Dialog" data-sentry-component="MoveProcessModal" data-sentry-source-file="move-process-modal.tsx" />;
};